import { PermissionsEnum } from '@/auth/interfaces';
import {
  EstadosActivacionInstallOTEnumChoice,
  // EstadosImagenChoiceEnum,
  // EstadosOrdenTrabajoEnumChoice,
  // EstadosOrdenTrabajoEnumChoice,
  TABLE_CONSTANTS,
  hasPermission,
  useCheckPermissions,
  useTableFilter,
  useTableServerSideFiltering,
} from '@/shared';
import { useFetchOrdenTrabajos } from '@/shared/actions/erp';
import {
  GeneralTable,
  // LoaderComponent,
  TableTabsScene,
} from '@/shared/components/ui';
import { OrdenTrabajo } from '@/shared/interfaces/erp/tecnico';
// import { useUploadImageStore } from '@/store/erp';
import { FotosPendingCellOTInstall } from '../../../shared/components/tables/fotos';
import { useColumnsInstalacionesOT } from '../../../shared/hooks';

export type FotosEntradaPendingTecOTInstallProps = {};

const FotosEntradaPendingTecOTInstall: React.FC<
  FotosEntradaPendingTecOTInstallProps
> = () => {
  useCheckPermissions(PermissionsEnum.api_view_ordentrabajo);

  ///* global state
  // const isUploadingImgs = useUploadImageStore(s => s.isUploading);

  // server side filters - colums table
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,

    dateBefore,
    dateAfter,
    // onChangeRangeDate,
    // cleanFilter,
  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;

  ///* fetch data
  const {
    data: instalacionesAgendadasPagingRes,
    isLoading,
    // isRefetching,
  } = useFetchOrdenTrabajos({
    enabled: true,
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      identificacion: searchTerm,
      ...filterObject,
      filterByState: false,
      // Solo instalaciones: traslados y visitas tienen su propio flujo de fotos.
      tipo_orden_servicio_exclude: "TRASLADO,VISITA",

      // estado_orden_trabajo: EstadoOrdenTrabajoCodigoEnum.EN_ESPERA,
      // estado_orden_trabajo: EstadosOrdenTrabajoEnumChoice.REALIZADA,
      // estado_imagen_entrada: EstadosImagenChoiceEnum.NO_CARGADO,
      fecha_hora_inicio_instalacion_isnull: false,
      estado_activacion: EstadosActivacionInstallOTEnumChoice.EN_ESPERA,
      // estado_orden_trabajo_exclude: `${EstadosOrdenTrabajoEnumChoice.PRE_RECHAZADO}`,

      fecha_hora_activacion_after: dateAfter,
      fecha_hora_instalacion_after: dateAfter,
      fecha_hora_activacion_before: dateBefore,
      fecha_hora_instalacion_before: dateBefore,
    },
  });

  ///* columns
  const { instalacionesAsignadasTecnicoColumns } = useColumnsInstalacionesOT();

  // if (isLoading || isRefetching || isUploadingImgs) return <LoaderComponent />;

  return (
    <TableTabsScene
      globalFilter={globalFilter}
      onChangeFilter={onChangeFilter}
      // searchInputText="por identificación de cliente"
      // onChangeRangeDate={onChangeRangeDate}
      // cleanFilter={cleanFilter}
    >
      <GeneralTable<OrdenTrabajo>
        columns={instalacionesAsignadasTecnicoColumns}
        data={instalacionesAgendadasPagingRes?.data?.data || []}
        //
        isLoading={isLoading}
        // isRefetching={isRefetching}
        // // filters - server side
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={instalacionesAgendadasPagingRes?.data?.count}
        // // actions
        actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH}
        // crud
        enableColumnActions={true}
        enableEditing={true}
        onCustomEdit={ordenTrabajo => {
          if (!hasPermission(PermissionsEnum.api_change_ordentrabajo)) return;

          return (
            <>
              <FotosPendingCellOTInstall
                ordenTrabajo={ordenTrabajo}
                isEntrada
              />
            </>
          );
        }}
        canDelete={false}
      />
    </TableTabsScene>
  );
};

export default FotosEntradaPendingTecOTInstall;
